export default __webpack_public_path__ + "static/ak-cached/24h/media/mob-care-bannerV2.de3d9eb1.jpg";